import React, { forwardRef } from "react";
import { Box } from "@mui/material";

const DSBox = forwardRef<HTMLDivElement, React.ComponentProps<typeof Box>>(
  (props, ref) => {
    return <Box ref={ref} {...props} />;
  },
);

DSBox.displayName = "DSBox";

export default DSBox;
